import * as at from './actionTypes';
import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/functions';
import { EventTypes } from 'redux-segment';
import history from '../../lib/history';
import { makeDebugger } from 'lib';
import Log from 'lib/Log';

const debug = makeDebugger('scenes/LandingFlow/actions');

export const emailChanged = (text) => {
  return {
    type: at.EMAIL_CHANGED,
    payload: text
  };
};

export const onDone = () => {
  return {
    type: at.SIGNUP_COMPLETE
  }
}

export const onSurveySubmit = (email) => {
  return dispatch => {
    dispatch({ type: at.SURVEY_SUBMIT });
    if (email && email.length > 0) {
      firebase.firestore().collection('waiting_list').doc(email)
        .set({
          surveyCompleted: true
        }, {
          merge: true
        }).then(() => {
          debug("success submitting survey")
          dispatch({ type: at.SURVEY_SUBMIT_SUCCESS })
        }).catch((err) => {
          Log.error(err.message, 'scenes/LandingFlow/actions')
          dispatch({ type: at.SURVEY_SUBMIT_FAILURE, payload: err })
        })
    } else {
      dispatch({ type: at.SURVEY_SUBMIT_SUCCESS })
    }
  }
}

const isValidEmail = (email) => {
  const regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gm
  const match = email.match(regex);
  debug("checking if email is valid, result: ", match);
	return match && match[0] === email;
}

const inWaitingList = (email) => {
  const waitingList = firebase.firestore().collection("waiting_list");
  return waitingList.doc(email).get()
    .then(doc => {
      if (doc.exists && doc.data().valid === true) {
        return {
          inWaitingList: true,
          surveyCompleted: doc.data().surveyCompleted
        }
      }
      return false;
    });
}

const inBeta = (email) => {
  const betaList = firebase.firestore().collection("beta_users");
  return betaList.doc(email).get()
    .then(doc => doc.exists && doc.data().beta === true);
}


const checkLists = (email) => {
  const waitingList = firebase.firestore().collection("waiting_list");
  return Promise.all([inBeta(email), inWaitingList(email)])
    .then(result => {
      return { inBeta: result[0], waitingList: result[1]}
    }).then((result) => {
      if (result.inBeta || !!(result.waitingList)) return result;
      debug(`adding ${email} to waiting list`)
      return waitingList.doc(email).set({ dateAdded: new Date(), valid: true })
        .then(() => { return { success: true } });
    });
}

export const addToWaitingList = (email) => {
  return (dispatch) => {
    if (!isValidEmail(email)) {
      dispatch({
        type: at.EMAIL_ADD_FAILURE,
        payload: 'Please enter a valid email.'
      });
      return;
    }
    dispatch({ type: at.EMAIL_ADD })
    // Identify in analytics
    window.analytics && window.analytics.identify(email);
    // call firebase function with email
    checkLists(email)
      .then(data => {
        if (data.inBeta) {
          debug("user already in Beta")
          // direct to login
          dispatch({ type: at.EMAIL_ADD_FAILURE })
          history.push(`/login?email=${email}`);
          return;
        }
        const action = {
          type: at.EMAIL_ADD_SUCCESS,
          meta: {
            analytics: {
              eventType: EventTypes.track,
              eventPayload: {
                event: 'Email Added',
                properties: {
                  type: 'waiting_list'
                }
              }
            }
          },
          payload: !!data.waitingList ? { ...data.waitingList } : {}
        };
        dispatch(action);
        history.push(`/login`)
        // Getting rid of survey for now... go directly to login
        // history.push(`/confirmation`)
      })
      .catch(err => {
        const message = err.code === 'aborted'
          ? "Please check your internet connection"
          : err.message
        dispatch({
          type: at.EMAIL_ADD_FAILURE,
          payload: message
        });
        Log.error(err.message, 'scenes/LandingFlow/actions');
      })
  }
}



// WEBPACK FOOTER //
// ./src/scenes/LandingFlow/actions.js